import { AgentStates, defaultAgentReport, IAgentReport, ITeamReport, MediaType, MediaTypes, WorkItemHandlingStats } from '../models/reports.internal';
import { ITeamReadModel } from '../models/team';
import { reduceWithSum } from '../utils/arrayUtils';
import { objectToArray } from '../utils/objectUtils';

function getHandlingStatByMedia(members: IAgentReport[], media: MediaType): WorkItemHandlingStats {
  const handled = reduceWithSum(members, (ar) => ar.workItemsByMedia[media].handled);
  const missed = reduceWithSum(members, (ar) => ar.workItemsByMedia[media].missed);
  const sumHandlingTime = reduceWithSum(members, (ar) => ar.workItemsByMedia[media].avgHandlingTime * ar.workItemsByMedia[media].handled);

  return {
    handled,
    missed,
    avgHandlingTime: Math.floor(sumHandlingTime / (handled || 1)),
  };
}

export function aggregateAgentProperties(agents: IAgentReport[], selector: (agent: IAgentReport) => Record<string, number>): Record<string, number> {
  const collector: Record<string, number> = agents.length > 0 ? {} : selector(defaultAgentReport(''));

  agents.forEach(a => {
    objectToArray(selector(a), (key, value) => { collector[key] = (collector[key] ?? 0) + value; });
  });

  return collector;
}

export default function aggregateAgentsIntoTeam(team: ITeamReadModel, agents: IAgentReport[]): ITeamReport {
  const members = agents.filter(a => team.memberIds.includes(a.id));

  return {
    id: team.id,
    name: team.name,
    memberIds: team.memberIds,
    memberReports: members,
    currentMemberAvailability: AgentStates.reduce((coll, state) => ({ ...coll, [state]: members.filter(m => m.currentState === state).length }), {} as ITeamReport['currentMemberAvailability']),
    timeSpentInStates: aggregateAgentProperties(members, m => m.timeSpentInStates),
    timeSpentInBreakNames: aggregateAgentProperties(members, m => m.timeSpentInBreakNames),
    workItemsByMedia: MediaTypes.reduce((coll, media) => ({ ...coll, [media]: getHandlingStatByMedia(members, media) }), {} as ITeamReport['workItemsByMedia']),
    workItemsByDispositionCode: aggregateAgentProperties(members, m => m.workItemsByDispositionCode),
  };
}